import httpClient from '../../fetch'
import { BankAccountModel } from './models'

export const getBanksByIds = (ids: string[] | string) => {
  const idsParam = Array.isArray(ids) ? ids.join(',') : ids
  return httpClient.get<BankAccountModel[]>(`/banking/${idsParam}`)
}
